import io from 'socket.io-client'
import { socketServerURL } from '../baseUrl'

/** Single socket for chat + global toasts (one connection per tab). */
let instance = null

export function getPortalSocket() {
  if (!instance) {
    instance = io(socketServerURL())
  }
  return instance
}
